import { IconButton, useDisclosure } from '@chakra-ui/react';
import { QuestionIcon } from '@chakra-ui/icons';
import {
  MyListScoreBreakdownModal,
  type MyListScoreBreakdownModalProps,
} from './modals/MyListScoreBreakdownModal';

type MyListScoreHelpButtonProps = Omit<MyListScoreBreakdownModalProps, 'isOpen' | 'onClose'> & {
  size?: string;
  fontSize?: string;
};

export function MyListScoreHelpButton(props: MyListScoreHelpButtonProps) {
  const { size = 'sm', fontSize = 'xs', ...modalProps } = props;
  const disclosure = useDisclosure();

  return (
    <>
      <IconButton
        aria-label='How my points arithmetic is calculated'
        icon={<QuestionIcon />}
        size={size}
        fontSize={fontSize}
        variant='ghost'
        minW={6}
        h={6}
        onClick={disclosure.onOpen}
      />
      <MyListScoreBreakdownModal
        isOpen={disclosure.isOpen}
        onClose={disclosure.onClose}
        {...modalProps}
      />
    </>
  );
}
